/*
 * @Author: zhaihaooran
 * @Date: 2021-06-07 15:13:12
 * @LastEditors: wyf
 */
/**
 * @description B端商业化价格的容器
 * @author liushuai
 */

import './planPricing.scss';
import React from 'react';
import { IProps, IUserInfo } from '@umu/umu-types';
import { If, PreImg } from 'common/src/components';
import { PricingTitle } from './components/@pricingTitle/pricingTitle';
import { PricingVersion } from './components/@pricingVersion/pricingVersion';
import { SchemeComparison } from './components/@schemeComparison/schemeComparison';
import { PricingEdition } from './components/@pricingEdition/pricingEdition';
import { PricingPartner } from './components/@pricingPartner/pricingPartner';
import { PricingFooter } from './components/@pricingFooter/pricingFooter';
import { lang } from '@umu/ukit-lang';

const leftIcon = require(`./images/head_top_left.png`);
const rightIcon = require(`./images/head_top_right.png`);
interface IPlanPricingProps extends IProps {
    userInfo?: IUserInfo;
}
export const PlanPricing = (props: IPlanPricingProps) => {
    return (
        <>
            <If condition={props.platform === 'twww'}>
                <section className="section-head-img">
                    <PreImg>
                        <img className="head-img-left" src={leftIcon} alt="" />
                    </PreImg>
                    <PreImg>
                        <img className="head-img-right" src={rightIcon} alt="" />
                    </PreImg>
                </section>
            </If>
            <div className="plan-pricing">
                <PricingTitle {...props} />
                <div className="version-category">
                    <div className="version-category-personal">{lang('个人')}</div>
                    <div className="version-category-team">{lang('团队和企业')}</div>
                </div>
                <PricingVersion {...props} />
                <SchemeComparison {...props} />
                <PricingPartner {...props} />
                <PricingEdition {...props} />
            </div>
            <PricingFooter {...props} />
        </>
    );
};
